// export default ActivityGauge;
import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ActivityGauge = ({ chartData }) => {
  const calculatePercentage = (count, total) => {
    return total > 0 ? ((count / total) * 100).toFixed(2) : 0;
  };
  const data = [
    {
      label: "Approved",
      value:
        calculatePercentage(chartData?.approved, chartData?.totalCount) || 0,
      color: "#6EC178",
    },
    {
      label: "Awaiting review",
      value:
        calculatePercentage(
          chartData?.awaiting_review,
          chartData?.totalCount
        ) || 0,
      color: "#4A90E2",
    },
    {
      label: "Partial",
      value:
        calculatePercentage(chartData?.partial, chartData?.totalCount) || 0,
      color: "#8C97A3",
    },
    {
      label: "Action required",
      value:
        calculatePercentage(
          chartData?.action_required,
          chartData?.totalCount
        ) || 0,
      color: "#FDA29B",
    },
  ];

  return (
    <div className="flex items-start gap-4">
      <div style={{ position: "relative", width: "250px", height: "250px", marginTop: "12px" }}>
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%) scale(${1 - index * 0.20})`,
              zIndex: data.length - index, 
            }}
          >
            <CircularProgressbar
              value={item.value}
              maxValue={100}
              strokeWidth={8} // Controls thickness of the circles
              styles={buildStyles({
                pathColor: item.color,
                trailColor: "#f0f0f0",
                strokeLinecap: "round",
                rotation: 0.25, // Adds slight rotation for better alignment
              })}
            />
          </div>
        ))}

        {/* Center Text */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          Status
        </div>
      </div>
      {/* Legend */}
      <div className="mt-4 text-center">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-start mb-2">
            <span
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: item.color,
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "8px",
              }}
            ></span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityGauge;
